// extracted by mini-css-extract-plugin
export default {"Portfolio":"Portfolio_Portfolio__9J-SF","btns":"Portfolio_btns__75R9x","projects":"Portfolio_projects__ppm0c","text":"Portfolio_text__18Vw5"};